import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { SubmitTradeReviewInput } from 'shared';

import { patchTradeReview } from '../../lib/api/endpoints';
import { notificationKeys } from '../notifications/queries';

import { reviewKeys } from './queries';
import { tradeReviewKeys } from './useReviewContext';

export function usePatchReview() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { tradeId: string; body: SubmitTradeReviewInput }) =>
      patchTradeReview(input),
    onSuccess: (_review, input) => {
      void queryClient.invalidateQueries({ queryKey: tradeReviewKeys.context(input.tradeId) });
      void queryClient.invalidateQueries({ queryKey: reviewKeys.all });
      void queryClient.invalidateQueries({ queryKey: reviewKeys.history(input.tradeId) });
      void queryClient.invalidateQueries({ queryKey: notificationKeys.all });
      void queryClient.invalidateQueries({ queryKey: ['tradePlans'] });
    },
  });
}
